import { useTranslation } from 'react-i18next';
import { SEOMeta } from '../components/SEOMeta';
import { BusinessModel as BusinessModelSection } from '../components/sections/solutions';
import { FinalCTA } from '../components/sections/home';
import { RelatedPages } from '../components/RelatedPages';

export function BusinessModel() {
  const { t } = useTranslation('solutions');

  return (
    <>
      <SEOMeta title={t('businessModel.heading')} description={t('businessModel.subtitle')} />

      <BusinessModelSection />
      <RelatedPages currentFrPath="/solutions/business-model" />
      <FinalCTA ns="solutions" prefix="businessModelCTA" />
    </>
  );
}
